import React, { Component } from 'react';
import { func, arrayOf, string, shape, bool } from 'prop-types';
import { connect } from 'react-redux';

import { orgJob as OrgJobPropType } from '../propTypes';
import Button from 'ps-components/Button/Button';
import Dropdown from 'ps-components/Dropdown/Dropdown';
import { Options } from 'ps-design';
import { SelectableItems } from 'ps-shared-ui/v3/SelectableItems';
import CopyMatchesResults from './CopyMatchesResults/CopyMatchesResults';
import ProgressStatusOverlay from 'ps-components/ProgressStatus/ProgressStatusOverlay';

import { hideSlideout } from 'ps-components/Slideout/SlideoutReducer';
import { getJobCodeKeys } from '../../JobMatching/OrgJobsActions';
import { propagateMatches } from '../../JobMatching/SurveyJobsActions';
import './CopyMatchesSlideout.scss';

const OPTIONS = ['All Job Code Keys', 'Search Job Code Keys'];
const DROPDOWN_OPTIONS = ['Create Additional Matches', 'Replace Current Matches'];

// TODO: Remaining items for GJM
// - Re-initialize state every time slideout opens (partially done -- if the id's change)
//    - Doesn't handle if you open/close on the same job
// - Error state render

class CopyMatchesSlideout extends Component {
  static propTypes = {
    hideSlideout: func,
    getJobCodeKeys: func,
    propagateMatches: func,
    jobCodeKeys: arrayOf(string),
    selectedJob: OrgJobPropType,
    selectedSurveyJobs: arrayOf(
      shape({
        surveyJobCode: string,
        surveyCode: string
      })
    ),
    loading: bool
  };

  state = {
    selectedKeys: [],
    selectedRadioOption: OPTIONS[0],
    method: DROPDOWN_OPTIONS[0]
  };

  getInitialState() {
    return {
      selectedKeys: [],
      selectedRadioOption: OPTIONS[0],
      method: DROPDOWN_OPTIONS[0]
    };
  }

  componentDidMount() {
    const { getJobCodeKeys, selectedJob } = this.props;
    getJobCodeKeys(selectedJob);
  }

  componentDidUpdate(prevProps) {
    const { getJobCodeKeys, selectedJob } = this.props;

    if (selectedJob.id && selectedJob.id !== prevProps.selectedJob.id) {
      this.setState(this.getInitialState());
      getJobCodeKeys(selectedJob);
    }
  }

  getOptions = (input, callback) => {
    const { jobCodeKeys } = this.props;
    if (input && input.length >= 1) {
      callback(
        input,
        jobCodeKeys.filter(key => key.includes(input))
      );
    }
  };

  handleItemSelect = items => {
    if (items) {
      const currentSelectedItems = Array.from(items);
      if (currentSelectedItems.length !== this.state.selectedKeys.length) {
        this.setState({ selectedKeys: currentSelectedItems });
      }
    }
  };

  handleCopyMatchesClick = () => {
    const { selectedKeys, selectedRadioOption, method } = this.state;
    const { jobCodeKeys, selectedJob, selectedSurveyJobs, propagateMatches } = this.props;
    const propagateKeys = selectedRadioOption === OPTIONS[0] ? jobCodeKeys : selectedKeys;
    const strategy = method === DROPDOWN_OPTIONS[0] ? 'CREATE' : 'OVERWRITE';

    propagateMatches(selectedJob.code, propagateKeys, selectedSurveyJobs, strategy);
  };

  handleMethodClick = event => {
    if (event === DROPDOWN_OPTIONS[0]) {
      this.setState({ method: DROPDOWN_OPTIONS[0] });
    } else if (event === DROPDOWN_OPTIONS[1]) {
      this.setState({ method: DROPDOWN_OPTIONS[1] });
    }
  };

  handleRadioSelect = () => {
    const newSelection = OPTIONS.filter(option => option !== this.state.selectedRadioOption);
    this.setState({ selectedRadioOption: newSelection[0] });
  };

  handleHideSlideout = () => {
    const { hideSlideout } = this.props;
    this.setState({
      selectedKeys: [],
      selectedRadioOption: OPTIONS[0],
      method: 'CREATE'
    });

    hideSlideout();
  };

  render() {
    const { selectedKeys, selectedRadioOption, method } = this.state;
    const { hideSlideout, jobCodeKeys, loading, propagatedMatches } = this.props;
    const possibleItems = jobCodeKeys.filter(item => !selectedKeys.includes(item));

    if (loading) {
      return (
        <div className="copy-matches-slideout__container">
          <ProgressStatusOverlay primaryText="Copying Matches..." secondaryText="This may take a moment" />
        </div>
      );
    }

    if (propagatedMatches && Object.keys(propagatedMatches).length > 0) {
      return (
        <div className="copy-matches-slideout__container">
          <div className="top__panel">
            <div className="copy-matches__header">
              <div className="pxl-header-xsmall bold-text copy-matches__header-title" />
              <div onClick={this.handleHideSlideout}>
                <i className="icon-cancel icon" />
              </div>
            </div>
            <div className="copy-matches__body">
              <CopyMatchesResults results={propagatedMatches} />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="copy-matches-slideout__container">
        <div className="top__panel">
          <div className="copy-matches__header">
            <div className="pxl-header-xsmall bold-text copy-matches__header-title">
              <i className="icon-docs" />
              <span className="copy-matches__header-title-text">Copy Matches from This Job to</span>
            </div>
            <div onClick={this.handleHideSlideout}>
              <i className="icon-cancel icon" />
            </div>
          </div>
          <div className="copy-matches__body">
            <Options
              id="copy-matches__radio-list"
              value={selectedRadioOption}
              options={OPTIONS}
              onChange={this.handleRadioSelect}
              syncOptions={false}
              type="radio"
              multiValue={false}
              className={`pxl-option-primary options__radio-btn`}
              loadMore={false}
            />
            {selectedRadioOption === OPTIONS[1] && (
              <SelectableItems
                className="job-code-key__values"
                initialItems={selectedKeys}
                possibleItems={possibleItems}
                headerText="Job Code Keys"
                searchCallback={this.getOptions}
                onItemsSelect={this.handleItemSelect}
              />
            )}
          </div>
        </div>
        <div className="bottom__panel">
          <div className="copy-matches__sub-footer">
            <div className="pxl-text-small">Method</div>
            <Dropdown
              className="pxl-btn pxl-btn-xs pxl-margin-small copy-matches__method-input"
              disabled={false}
              dropdownItems={DROPDOWN_OPTIONS}
              dropdownClass="copy-matches__dropdown-items"
              itemOnClick={this.handleMethodClick}
              text={method}
            />
          </div>
          <div className="copy-matches__footer">
            <a className="copy-matches__link" onClick={hideSlideout}>
              Cancel
            </a>
            <Button className="matches__btn pxl-btn pxl-btn-primary" onClick={this.handleCopyMatchesClick}>
              Copy Matches
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ orgJobs, surveyJobs }) => ({
  selectedJob: orgJobs.selectedJob,
  jobCodeKeys: orgJobs.jobCodeKeys,
  selectedSurveyJobs: surveyJobs.selectedSurveyJobCodes,
  loading: surveyJobs.propMatches.loading,
  propagatedMatches: surveyJobs.propMatches.propagatedMatches
});

export default connect(mapStateToProps, { hideSlideout, getJobCodeKeys, propagateMatches })(CopyMatchesSlideout);
